import { IAbmBuscador, ITableSearchConfig } from "./../../../interfaces/pages/abm/abm-buscador.interface";
import { Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { ModalSize } from "@signal/component-library/efx-modal";
import { EnumAbmBuscadorFlow } from "src/app/enums/shared/abm-buscador-enum";

@Component({
    selector: "app-modal-abm-buscador",
    templateUrl: "./modal-abm-buscador.component.html",
    styleUrls: ["./modal-abm-buscador.component.scss"],
    standalone: false
})
export class ModalAbmBuscadorComponent {
  @Input() modalSize: ModalSize;
  @Input() showModal: boolean = true;
  @Input() inData = [];
  @Input() flowTableModal: EnumAbmBuscadorFlow;
  @Input() inStructModal: ITableSearchConfig[];
  @Input() itemMenuSelected: IAbmBuscador;

  @Output() onCloseModal: EventEmitter<any> = new EventEmitter();
  @Output() onSaveModal: EventEmitter<any> = new EventEmitter();

  get OptionsFlowTable(): typeof EnumAbmBuscadorFlow {
    return EnumAbmBuscadorFlow;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Modal Abm Buscador - onChanges - changes:', changes);
    console.log('Modal Abm Buscador - onChanges - itemMenuSelected:', this.itemMenuSelected);
    console.log('Modal Abm Buscador - onChanges - flowTableModal:', this.flowTableModal);
    console.log("Modal Abm Buscador - onChanges - inData:", this.inData);
  }

  closetModal() {
    this.onCloseModal.emit();
  }

  onSubmit() {
    this.onSaveModal.emit();
  }
}
